

define(['jquery', 'squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-models/src/fi/index'], function ($, squid, template) {

    return squid.module('xo-member-sepa.sepaAgreement.directive', ['squid', 'xomodel.checkout', 'xomodel.fi']).directive('xoSepaAgreement', function ($rootScope) {

        return {
            template: template,

            scope: {
                token: '=',
                sepa: '=',
                parentCallbacks: '='
            },

            controller: function controller($scope, $CheckoutSessionModel, $SepaModel, $populate) {

                $('body').addClass('pageSepaAgreementContingency');

                $scope.$on('$destroy', function () {
                    $('body').removeClass('pageSepaAgreementContingency');
                });

                $populate($scope, {
                    checkoutSession: $CheckoutSessionModel.instance($scope.token)
                }).then(function () {
                    $scope.sepa.bankId = $scope.checkoutSession.sepa_mandate.bankId;
                    $scope.sepa.action('sepaDirectMandate', {
                        resultModel: $scope.sepa,

                        data: {
                            bank: {
                                id: $scope.sepa.bankId
                            }
                        },

                        success: function success() {
                            $scope.onSubmit = function () {
                                $scope.parentCallbacks.sepaAccept();
                            };
                        }
                    });
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/member-sepa/sepaAgreement/directive.js
 ** module id = 437
 ** module chunks = 1
 **/